<div class="filter-container" [class.collapsed]="isFilterCollapsed">
    <div class="filter-header" (click)="toggleFilter()">
        <h5 class="filter-title">
            <i class="fas fa-filter"></i>
            Center Mapping - Search Criteria
        </h5>
        <div class="collapse-toggle">
            <i class="fas" [class.fa-chevron-up]="!isFilterCollapsed" [class.fa-chevron-down]="isFilterCollapsed"></i>
        </div>
    </div>



    <div class="filter-content">


        <form [formGroup]="centerMappingForm">
            <div class="row gx-3 align-items-end">
                <!-- Center search textbox -->
                <div class="form-group col-md-8 mb-3">
                    <label class="form-label">
                        {{ getTranslation('studyParticipation.currentCentre') }}
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        formControlName="CenterSearchTerm"
                        [placeholder]="getTranslation('studyParticipation.searchCentre') || 'Search Center Name...'"
                        (input)="onCenterSearchInput($event)"
                        (keyup.enter)="onSearch()"
                        autocomplete="off">
                    <small class="form-text text-muted" *ngIf="!centerMappingForm.controls['CenterSearchTerm']?.value">
                        {{ getTranslation('common.searchHint') || 'Type at least 3 characters to search' }}
                    </small>
                </div>

                <!-- Search Button -->
                <div class="form-group col-md-2 mb-3">
                    <button type="button" class="btn btn-primary search-btn" (click)="onSearch()">
                        <i class="fas fa-search"></i> {{ getTranslation('common.search') }}
                    </button>
                </div>

                <!-- Clear Button -->
                <div class="form-group col-md-2 mb-3">
                    <button type="button" class="btn btn-secondary clear-btn" (click)="onClear()">
                        <i class="fas fa-times"></i> {{ getTranslation('common.clear') }}
                    </button>
                </div>
            </div>
        </form>


    </div>
</div>

<app-application-list-grid #gridComponent [gridPermissionByRole]="gridPermissionByRole" [columnDefs]="columnDefs" [showActionColumn]="showActionColumn" [gridData]="gridData"></app-application-list-grid>